import React from 'react';
import ComposeWithTemplate from './ComposeWithTemplate';

const IntroMessageStep: React.FC = () => <ComposeWithTemplate intent="intro" />;

export default IntroMessageStep;
